const form = {
	formId: "new-special-form",
	formField: {
		emails: {
			name: "emails",
			label: "Emails",
			type: "select",
			placeholder: "one email per line",
			errorMsg: "Atleast one email is required.",
		},
	},
};

export default form;
